import React, { useCallback, useMemo } from 'react'
import { isOverviewModuleData } from '../../../types/ModuleData'
import OverlaySideWindow from '../../components/OverlaySideWindow'
import Buttons from '../../components/propertyControls/Buttons'
import DropDown from '../../components/propertyControls/DropDown'
import { getNumberedModuleTitles } from '../../model/ConstelaConfiguration'
import { useDispatch, useSelector } from '../../store/hooks'
import { usePropertiesForModule } from '../../store/hooks/dataHooks'
import { isDefined } from '../../utils/typeGuards'

const ModulePropertyOverlay: React.FC = () => {
  const moduleIndex = useSelector((state) => {
    const module = state.ui.expert.showProperties?.module
    return typeof module === 'number' ? module : undefined
  })
  const modules = useSelector((state) => state.configuration.expertMode.modules)
  const availableModules = useSelector((state) => state.data.modules)
  const moduleTitles = useMemo(() => getNumberedModuleTitles(modules, availableModules), [availableModules, modules])
  const module = isDefined(moduleIndex) ? modules?.[moduleIndex] : undefined
  const moduleTitle = isDefined(moduleIndex) ? moduleTitles?.[moduleIndex] : undefined
  const moduleData = useSelector((state) =>
    state.data.modules?.filter(isOverviewModuleData).find((x) => x.id === module?.id)
  )

  const { properties, propertyData, setProperty } = usePropertiesForModule(moduleIndex)

  const dispatch = useDispatch()
  const close = useCallback(() => {
    dispatch({
      type: 'UI/Expert/ShowPropertyOverlay',
      payload: undefined
    })
  }, [dispatch])

  return (
    <OverlaySideWindow
      visible={!!module}
      title={moduleTitle}
      currentKey={'module-properties-' + moduleIndex}
      close={close}
    >
      {moduleData?.propertyMenu?.map((menuItem) => {
        if (!propertyData[menuItem.property]) {
          return
        }
        if (menuItem.controlType === 'dropdown') {
          return (
            <DropDown
              key={menuItem.property}
              propertyData={propertyData[menuItem.property]}
              value={properties[menuItem.property]}
              setValue={setProperty[menuItem.property]}
            />
          )
        }
        if (menuItem.controlType === 'buttons') {
          return (
            <Buttons
              key={menuItem.property}
              propertyData={propertyData[menuItem.property]}
              value={properties[menuItem.property]}
              setValue={setProperty[menuItem.property]}
            />
          )
        }
      })}
    </OverlaySideWindow>
  )
}

export default ModulePropertyOverlay
